/* マップ */
import map_1803 from "./map/map-1803.jpg"
import map_1818 from "./map/map-1818.jpg"
import map_1820 from "./map/map-1820.jpg"
import map_2003 from "./map/map-2003.jpg"
import map_2005 from "./map/map-1818.jpg"
import map_2006 from "./map/map-2006.jpg"
import map_2020 from "./map/map-2020.jpg"
import map_break from "./map/map-break.png"

/* ピン */
import pin1 from "./map/pin1.png"
import pin2 from "./map/pin2.png"

import { memo } from "react"

const Map = memo((props) => {
    const { current, position, move1803_1, move1803_2, move1818_1, move1818_2, move1820_1, move1820_2, move2003_1, move2003_2,
        move2005_1, move2005_2, move2006_1, move2006_2, move2020_1, move2020_2, moveB_1, moveB_2, moveB_3} = props
    
    if(current === "1803"){
        return(
            <div className='map'>
                <div className='container'>
                    <img className="map-img" alt="" src="/static/media/map-1803.52f7311255635971dccb.jpg"/>
                    {position === 1 ?
                    <>
                    <button className='pin pin1803-1' onClick={move1803_1}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pin1803-2' onClick={move1803_2}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    <button className='pin pin1803-1' onClick={move1803_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pin1803-2' onClick={move1803_2}><img className="pin2" alt="" src={pin2}/></button>
                    </>
                    }
                    
                </div>
            </div>
        )
    }else if(current === "1818"){
        return(
            <div className='map'>
                <div className='container'>
                    <img className="map-img" alt="" src="/static/media/map-1818.0e8f1434ba9aa29cdcb5.jpg"/>
                    {position === 1 ?
                    <>
                    <button className='pin pin1818-1' onClick={move1818_1}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pin1818-2' onClick={move1818_2}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    <button className='pin pin1818-1' onClick={move1818_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pin1818-2' onClick={move1818_2}><img className="pin2" alt="" src={pin2}/></button>
                    </>
                    }
                    
                </div>
            </div>
        )
    }else if(current === "1820"){
        return(
            <div className='map'>
                <div className='container'>
                    <img className="map-img" alt="" src="/static/media/map-1820.8100aeef31e0cd1fb468.jpg"/>
                    {position === 1 ?
                    <>
                    <button className='pin pin1820-1' onClick={move1820_1}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pin1820-2' onClick={move1820_2}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    <button className='pin pin1820-1' onClick={move1820_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pin1820-2' onClick={move1820_2}><img className="pin2" alt="" src={pin2}/></button>
                    </>
                    }
                    
                </div>
            </div>
        )
    }else if(current === "2003"){
        return(
            <div className='map'>
                <div className='container'>
                    <img className="map-img" alt="" src="/static/media/map-2003.b699f592d47611cf74d0.jpg"/>
                    {position === 1 ?
                    <>
                    <button className='pin pin2003-1' onClick={move2003_1}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pin2003-2' onClick={move2003_2}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    <button className='pin pin2003-1' onClick={move2003_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pin2003-2' onClick={move2003_2}><img className="pin2" alt="" src={pin2}/></button>
                    </>
                    }
                    
                </div>
            </div>
        )
    }else if(current === "2005"){
        return(
            <div className='map'>
                <div className='container'>
                    <img className="map-img" alt="" src="/static/media/map-1818.0e8f1434ba9aa29cdcb5.jpg"/>
                    {position === 1 ?
                    <>{/* 1818と2005はおなじ */}
                    <button className='pin pin1818-1' onClick={move2005_1}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pin1818-2' onClick={move2005_2}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    <button className='pin pin1818-1' onClick={move2005_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pin1818-2' onClick={move2005_2}><img className="pin2" alt="" src={pin2}/></button>
                    </>
                    }
                    
                </div>
            </div>
        )
    }else if(current === "2006"){
        return(
            <div className='map'>
                <div className='container'>
                    <img className="map-img" alt="" src="/static/media/map-2006.f8df58e64cffce9925f1.jpg"/>
                    {position === 1 ?
                    <>
                    <button className='pin pin2006-1' onClick={move2006_1}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pin2006-2' onClick={move2006_2}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    <button className='pin pin2006-1' onClick={move2006_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pin2006-2' onClick={move2006_2}><img className="pin2" alt="" src={pin2}/></button>
                    </>
                    }
                    
                </div>
            </div>
        )
    }else if(current === "2020"){
        return(
            <div className='map'>
                <div className='container'>
                    <img className="map-img" alt="" src="/static/media/map-2020.62438317452214fe185b.jpg"/>
                    {position === 1 ?
                    <>
                    <button className='pin pin2020-1' onClick={move2020_1}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pin2020-2' onClick={move2020_2}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    <button className='pin pin2020-1' onClick={move2020_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pin2020-2' onClick={move2020_2}><img className="pin2" alt="" src={pin2}/></button>
                    </>
                    }
                    
                </div>
            </div>
        )
    }else if(current === "Break"){
        return(
            <div className='map'>
                <div className='container'>
                    <img className="map-img" alt="" src={map_break}/>
                    {position === 1 ?
                    <>
                    <button className='pin pinB-1' onClick={moveB_1}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pinB-2' onClick={moveB_2}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pinB-3' onClick={moveB_3}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    {position === 2 ?
                    <>
                    <button className='pin pinB-1' onClick={moveB_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pinB-2' onClick={moveB_2}><img className="pin2" alt="" src={pin2}/></button>
                    <button className='pin pinB-3' onClick={moveB_3}><img className="pin1" alt="" src={pin1}/></button>
                    </>
                    :
                    <>
                    <button className='pin pinB-1' onClick={moveB_1}><img className="pin1" alt="" src={pin1}/></button>
                    <button className='pin pinB-2' onClick={moveB_2}><img className="pin2" alt="" src={pin1}/></button>
                    <button className='pin pinB-3' onClick={moveB_3}><img className="pin1" alt="" src={pin2}/></button>
                    </>
                    }
                    </>
                    }
                    
                </div>
            </div>
        )
    }else{
        return(<></>)
    }
})
export default Map